<div class="p-3">
  <div class="search-bar">
    <input type="text" placeholder="Search icons..." [(ngModel)]="searchTerm" />
  </div>

  <div class="icon-gallery">
    @for (icon of filteredIcons; track icon) {
    <div class="icon-item" role="button" (click)="copyIcon(icon)">
      <app-icon [name]="icon" size="32" color="#1677ff"></app-icon>
      <div class="icon-name">{{ icon }}</div>
    </div>
    }

    @if (filteredIcons.length === 0) {
    <div class="no-results">
      No icons found.
    </div>
    }
  </div>
</div>
